<template>
	<div class='journal-toolbar'>

		<div class='toolbar-btn-block'>

			<!-- <button v-if='selectedLpo && !modeMap' @click='enableModeMap'>Карта</button> -->
			<!-- <button v-if='modeMap' @click='disableModeMap' >Таблица</button> -->
			<button v-if='journalIsFiltered && !modeMap' @click='clearFilter'>Отменить все фильтры</button>
			<p-button label='Отчет об использовании системы' @click='openUseReportModal' class='p-button-sm' />
		</div>

		<div class='pagination-container'>
			<journal-pagination></journal-pagination>
		</div>

		<UseReportModal :isOpen.sync='useReportModalIsOpen' />

	</div>
</template>

<script>
	import { mapState, mapGetters, mapActions } from 'vuex';

	import JournalPagination from './JournalLpo__pagination';
	import UseReportModal from './JournalLpo__useReport';

	export default {
		name: 'JournalLpo',
		components: {
			JournalPagination,
			UseReportModal
		},
		data() {
			return {
				modeMap: false,

				useReportModalIsOpen: false
			};
		},
		computed: {
			...mapState('journalLpo', {
				selectedLpo: state => state.selectedJournalLpo,
			}),

			...mapGetters('journalLpo', [
				'totalPages',
				'journalIsFiltered',
			])
		},
		methods: {

			openUseReportModal() {
				this.useReportModalIsOpen = true;
			},

			clearFilter() {
				this.clearFilterAll().then(res => {
					this.getJournalLpo();
				});
			},

			enableModeMap() {
				this.modeMap = true;
			},
			disableModeMap() {
				this.modeMap = false;
			},

			...mapActions('journalLpo', [
				'getJournalLpo',
				'clearFilterAll'
			])
		}
	};
</script>

<style scoped>
	.journal-toolbar {
		padding: 10px 20px;
		display: flex;
	}

	.toolbar-btn-block {
		flex: 1;
	}

	.toolbar-btn-block > button {
		margin-right: 6px;
	}
</style>